import React, { useEffect, useRef, useState } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import { TabContext } from "@mui/lab";

import "./Section.css";
import SuccessAlert from "../components/success-alert/SuccessAlert";
import ErrorAlert from "../components/error-alert/ErrorAlert";
import useLanguages from "../hooks/useLanguages";
import { API, SERVER_DOMAIN } from "../assets/staticData";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  TextField,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { toast } from "react-toastify";
import ClearCacheButton from "../components/ClearCacheButton/ClearCacheButton";
import { CACHE_KEY } from "../constant/cache-key";

export default function SEO({ user }) {
  const langs = useLanguages();

  const [value, setValue] = useState("0");
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [fail, setFail] = useState(false);
  const [loading, setLoading] = useState(true);
  const [expand, setExpand] = useState();
  const imageRefs = useRef([]);

  let userToken = localStorage.getItem("userToken");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let tabStyle = { textTransform: "capitalize", fontWeight: "500" };

  useEffect(() => {
    let docs = langs.map((item, idx) => ({
      pages:
        idx === 0
          ? [
            {
              label: "Home",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "About",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Blog",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Platforms",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Help Center",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Deposit & Withdrawal",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Account Types",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Market",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Privacy Policy",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "FAQ",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Margin Calculator",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Profit & Loss Calculator",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
            {
              label: "Spread Calculator",
              metaTitle: "",
              metaDesc: "",
              socialTitle: "",
              socialDesc: "",
              socialImg: "",
              keywords: "",
              indexingRules: "",
              schema: "",
            },
          ]
          : [],
      language: item.attributes.language,
    }));

    setData(docs);

    async function getData() {
      setLoading(true);
      await fetch(`${API}/seo`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userToken}`,
        },
      }).then(async (res) => {
        const response = await res.json();
        const apiData = response.data?.attributes?.seoData || [];

        setData(apiData)

        setLoading(false);
      });
    }

    getData();
  }, [langs]);

  const handleInputChange = (e, index, pageIndex, field) => {
    const newValue = e.target.value;
    setData((prevData) => {
      const updatedData = [...prevData];
      updatedData[index].pages[pageIndex][field] = newValue;
      return updatedData;
    });
  };

  const handleImageUpload = (e, index, idx) => {
    const formData = new FormData();
    const file = e.target.files[0];

    if (file) {
      formData.append("files", file);

      fetch(`${API}/upload`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
        body: formData,
      }).then(async (res) => {
        const response = await res.json();
        const iconURL = response[0]?.url;

        let updatedData = [...data];
        updatedData[index].pages[idx].socialImg = iconURL;

        fetch(`${API}/seo`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userToken}`,
          },
          body: JSON.stringify({
            data: { seoData: updatedData },
          }),
        }).then((res) => {
          if (res.ok) {
            setData(updatedData);
            toast("Updated Successfully", {
              position: "top-center",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              type: "success",
            });
          }
        });
      });
    }
  };

  const submitData = (item, index) => {
    setExpand(null);
    fetch(`${API}/seo`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userToken}`,
      },
      body: JSON.stringify({
        data: { seoData: data },
      }),
    }).then(async (res) => {
      if (res.ok) {
        setSuccess(true);
      } else {
        setFail(true);
      }
    });
  };

  const handleCheckboxChange = (e, pageIndex, idx) => {
    const { checked, name } = e.target;
    setData((prevData) => {
      const updatedData = [...prevData];
      let rules = updatedData[pageIndex].pages[idx].indexingRules || "";

      if (checked) {
        // Add the label to the string
        rules = rules ? `${rules},${name}` : name;
      } else {
        // Remove the label from the string
        const rulesArray = rules.split(",");
        rulesArray.splice(rulesArray.indexOf(name), 1);
        rules = rulesArray.join(",");
      }

      updatedData[pageIndex].pages[idx].indexingRules = rules;
      return updatedData;
    });
  };

  return (
    <TabContext value={value}>
      <ClearCacheButton keys={[CACHE_KEY.seo]} />

      <Box sx={{ width: "100%" }}>
        <h3 style={{ textTransform: "capitalize" }}>SEO Settings</h3>
        <Tabs
          value={value}
          onChange={handleChange}
          textColor="secondary"
          indicatorColor="secondary"
          aria-label="secondary tabs"
        >
          {langs?.map((item, index) => {
            return (
              <Tab
                key={index}
                sx={tabStyle}
                value={index.toString()}
                label={item.attributes.language}
                icon={
                  <img
                    src={
                      SERVER_DOMAIN + item.attributes.icon.data.attributes.url
                    }
                    style={{ width: 25, aspectRatio: 1, borderRadius: 20 }}
                  />
                }
                iconPosition="start"
              />
            );
          })}
        </Tabs>

        {loading ? (
          <></>
        ) : (
          <>
            {langs?.map((item, index) => {
              return (
                <TabPanel value={index.toString()} key={index}>
                  <SuccessAlert show={success} setShow={(v) => setSuccess(v)} />
                  <ErrorAlert show={fail} setShow={(v) => setFail(v)} />

                  <div
                    style={{
                      pointerEvents: user.perms[2].edit ? null : "none",
                    }}
                  >
                    {data[index]?.pages.map((item, idx) => (
                      <div
                        key={idx}
                        className="p-4 w-full rounded-md shadow-md mb-2 transition-all delay-100 cursor-pointer overflow-hidden border"
                        style={{
                          maxHeight: expand == idx ? 600 : 60,
                          minHeight: 60,
                        }}
                        onClick={() => {
                          if (expand == idx) {
                            setExpand(null);
                          } else {
                            setExpand(idx);
                          }
                        }}
                      >
                        <KeyboardArrowDownIcon
                          style={{
                            transform: expand == idx ? "rotate(180deg)" : null,
                            transition: "0.2s",
                            fontSize: 30,
                            marginRight: 7,
                          }}
                        />
                        {item.label}
                        <div
                          className="w-full mt-4 p-4 flex flex-wrap gap-6"
                          style={{
                            transition: "0.3s",
                            visibility: expand == idx ? "visible" : "hidden",
                            opacity: expand == idx ? 1 : 0,
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                            cursor: "auto",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <TextField
                              sx={{ width: "100%" }}
                              label="Meta Title"
                              variant="outlined"
                              multiline
                              rows={2}
                              value={data[index]?.pages[idx]?.metaTitle || ""}
                              onChange={(e) =>
                                handleInputChange(e, index, idx, "metaTitle")
                              }
                            />
                          </div>
                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <TextField
                              sx={{ width: "100%" }}
                              label="Meta Description"
                              variant="outlined"
                              multiline
                              rows={2}
                              value={data[index]?.pages[idx]?.metaDesc || ""}
                              onChange={(e) =>
                                handleInputChange(e, index, idx, "metaDesc")
                              }
                            />
                          </div>
                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <TextField
                              sx={{ width: "100%" }}
                              label="Social Title"
                              variant="outlined"
                              multiline
                              rows={2}
                              value={data[index]?.pages[idx]?.socialTitle || ""}
                              onChange={(e) =>
                                handleInputChange(e, index, idx, "socialTitle")
                              }
                            />
                          </div>
                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <TextField
                              sx={{ width: "100%" }}
                              label="Social Description"
                              variant="outlined"
                              multiline
                              rows={2}
                              value={data[index]?.pages[idx]?.socialDesc || ""}
                              onChange={(e) =>
                                handleInputChange(e, index, idx, "socialDesc")
                              }
                            />
                          </div>
                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <TextField
                              sx={{ width: "100%" }}
                              label="Keywords"
                              variant="outlined"
                              multiline
                              rows={3}
                              value={data[index]?.pages[idx]?.keywords || ""}
                              onChange={(e) =>
                                handleInputChange(e, index, idx, "keywords")
                              }
                            />
                            <p style={{ fontSize: 13, marginTop: 3 }}>
                              Seperate each Keyword by a ","
                            </p>
                          </div>
                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <TextField
                              sx={{ width: "100%" }}
                              label="Schema"
                              variant="outlined"
                              multiline
                              rows={3}
                              value={data[index]?.pages[idx]?.schema || ""}
                              onChange={(e) =>
                                handleInputChange(e, index, idx, "schema")
                              }
                            />
                          </div>
                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <FormGroup
                              style={{ flexDirection: "row", flexWrap: "wrap" }}
                            >
                              {[
                                "Index",
                                "No Index",
                                "Nofollow",
                                "No Archive",
                                "No Image Index",
                                "No Snippet",
                              ].map((label, i) => (
                                <FormControlLabel
                                  key={i}
                                  style={{ width: "45%" }}
                                  control={
                                    <Checkbox
                                      name={label}
                                      checked={
                                        data[index]?.pages[idx]?.indexingRules
                                          ?.split(",")
                                          .includes(label) || false
                                      }
                                      onChange={(e) =>
                                        handleCheckboxChange(e, index, idx)
                                      }
                                    />
                                  }
                                  label={label}
                                />
                              ))}
                            </FormGroup>
                          </div>

                          <div
                            style={{
                              flexBasis: "calc(50% - 12px)",
                              minWidth: 300,
                            }}
                          >
                            <h3>Social Image</h3>
                            <div
                              className="flex gap-2 mt-2"
                              style={{ justifyContent: "flex-start" }}
                            >
                              <img
                                src={
                                  data[index]?.pages[idx]?.socialImg
                                    ? SERVER_DOMAIN +
                                    data[index]?.pages[idx]?.socialImg
                                    : require("../assets/placeholder-image.png")
                                }
                                className="w-32 rounded-md aspect-[4/3] object-cover"
                              />
                              <input
                                type="file"
                                ref={(el) => (imageRefs.current[idx] = el)}
                                onChange={(e) =>
                                  handleImageUpload(e, index, idx)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {user.perms[2].edit && (
                    <div
                      className="submitBTN"
                      onClick={() => submitData(item, index)}
                    >
                      Save Changes
                    </div>
                  )}
                </TabPanel>
              );
            })}
          </>
        )}
      </Box>
    </TabContext>
  );
}
